import { render, staticRenderFns } from "./MarkingExamDetailModal.vue?vue&type=template&id=0573ba42"
import script from "./MarkingExamDetailModal.vue?vue&type=script&lang=js"
export * from "./MarkingExamDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports